<ng-container *ngFor="let subtask of subtasks; let i = index; let first = first">
  <div class="row subtasks" [ngStyle]="{ 'padding-top': '16px' }">
    <div class="col col-xs-12 subtask-container">
      <div class="subtask-icon">
        <ng-container *ngIf="subtask.status === 'Completed'; else SubtaskIncomplete">
          <mat-icon class="subtask-completed">check</mat-icon>
        </ng-container>
        <ng-template #SubtaskIncomplete>
          <span class="subtask-incomplete" (click)="handleNonClickableClicked('taskNumber')">
            {{ (i + 1).toString() }}
          </span>
        </ng-template>
      </div>
      <div class="subtask-details">
        <div class="subtask-title" (click)="handleNonClickableClicked('taskTitle')">
          {{ subtask.title }}
        </div>
        <div [ngSwitch]="subtask.status" (click)="handleNonClickableClicked('taskDueDate')">
          <div *ngSwitchCase="'Completed'">
            {{ 'PROJECT_TRACKER.COMPLETED_ON' | translate : { date: (subtask.completionDate | date : 'longDate') } }}
          </div>
          <div *ngSwitchCase="'In Progress'">
            <span class="subtask-in-progress">
              {{ 'PROJECT_TRACKER.IN_PROGRESS' | translate }}
            </span>
            <ng-container *ngIf="subtask.dueDate; else noInProgressDueDate">
              <span>
                -
                {{
                  'PROJECT_TRACKER.ESTIMATED_COMPLETION' | translate : { date: (subtask.dueDate | date : 'longDate') }
                }}
              </span>
            </ng-container>
            <ng-template #noInProgressDueDate>
              <span>
                -
                {{ 'PROJECT_TRACKER.ESTIMATED_COMPLETION' | translate : { date: 'TBD' } }}
              </span>
            </ng-template>
          </div>
          <div *ngSwitchCase="'Waiting on Customer'">
            <div class="subtask-waiting-on-customer">
              {{ 'PROJECT_TRACKER.WAITING_ON_CUSTOMER' | translate }}
            </div>
          </div>
          <div *ngSwitchDefault>
            <ng-container *ngIf="subtask.dueDate; else noIncompleteDueDate">
              <span>
                {{
                  'PROJECT_TRACKER.ESTIMATED_COMPLETION' | translate : { date: (subtask.dueDate | date : 'longDate') }
                }}
              </span>
            </ng-container>
            <ng-template #noIncompleteDueDate>
              <span>
                {{ 'PROJECT_TRACKER.ESTIMATED_COMPLETION' | translate : { date: 'TBD' } }}
              </span>
            </ng-template>
          </div>
          <div *ngIf="subtask.approved">
            <span>
              {{ 'PROJECT_TRACKER.YOU_APPROVED' | translate : { title: subtask.title } }}
            </span>
          </div>
        </div>
        <div
          class="subtask-notes"
          *ngIf="subtask.notes || subtask.conversations?.length > 0 || subtask.files?.length > 0"
        >
          <div *ngIf="subtask.notes" markdown ngPreserveWhitespaces (click)="handleNonClickableClicked('taskNotes')">
            {{ subtask.notes }}
          </div>
          <div
            class="feedback-item"
            *ngFor="let feedback of subtask.conversations"
            (click)="handleNonClickableClicked('taskFeedback')"
          >
            <ng-container *ngIf="feedback?.isPublic && feedback?.message">
              <div
                *ngIf="feedback.source === 'smb' || feedback.persona === PersonaType.PERSONA_TYPE_SMB"
                class="feeback-item-title"
              >
                {{ 'PROJECT_TRACKER.YOU_REQUESTED_REVISIONS' | translate : { title: subtask.title } }}
              </div>
              <div *ngIf="feedback.persona === PersonaType.PERSONA_TYPE_DIGITAL_AGENT" class="feeback-item-title">
                {{ 'PROJECT_TRACKER.FULFILLMENT_TEAM_MESSAGE' | translate }}
              </div>
              <div
                *ngIf="
                  feedback.persona !== PersonaType.PERSONA_TYPE_DIGITAL_AGENT &&
                  feedback.persona !== PersonaType.PERSONA_TYPE_SMB
                "
                class="feeback-item-title"
              >
                {{ 'PROJECT_TRACKER.GENERIC_MESSAGE' | translate }}
              </div>
              <div class="feeback-item-content">
                {{ feedback?.message }}
              </div>
            </ng-container>
          </div>
          <div
            class="attached-file"
            *ngFor="let file of subtask.files"
            (click)="handleNonClickableClicked('taskAttachments')"
          >
            <mat-icon class="attachment-icon">attachment</mat-icon>
            {{ file.name }}
          </div>
        </div>
        <ng-container *ngIf="subtask.feedbackEnabled">
          <div *ngIf="subtask.showFeedback" class="feedback-input">
            <form [formGroup]="subtask.form">
              <mat-form-field appearance="outline" class="feedback-textarea">
                <mat-label>
                  {{ 'PROJECT_TRACKER.REVISIONS' | translate }}
                </mat-label>
                <textarea
                  matInput
                  [formGroup]="subtask.form"
                  [formControlName]="getFeedbackControlName(i)"
                  cdkTextareaAutosize
                  cdkAutosizeMaxRows="5"
                  cdkAutosizeMinRows="2"
                ></textarea>
              </mat-form-field>
              <forms-file-group-uploader
                class="project-tracker-uploader"
                [customUploader]="attachmentUploader"
                [label]="'PROJECT_TRACKER.FILE_UPLOAD_PROMPT' | translate"
                [enableDownload]="false"
                [numFiles]="10"
                [formGroup]="subtask.form"
                [formControlName]="getFilesControlName(i)"
                (fileUploaded)="onFileUploaded($event, i)"
                (fileUploadError)="onFileError()"
                (fileRemoved)="onFileRemoved($event, i)"
              ></forms-file-group-uploader>
            </form>
          </div>
          <div class="feedback-buttons">
            <ng-container *ngIf="!subtask.showFeedback">
              <button mat-button class="feedback-button" color="primary" (click)="toggleShowFeedback(i)">
                {{ 'PROJECT_TRACKER.PROVIDE_FEEDBACK' | translate }}
              </button>
              <button
                mat-raised-button
                color="accent"
                class="feedback-approve"
                (click)="approveTask(i)"
                [disabled]="subtask.approved"
              >
                {{ 'PROJECT_TRACKER.APPROVE' | translate }}
              </button>
            </ng-container>
            <ng-container *ngIf="subtask.showFeedback">
              <button mat-button class="feedback-button" color="primary" (click)="toggleShowFeedback(i)">
                {{ 'PROJECT_TRACKER.CANCEL' | translate }}
              </button>
              <button
                mat-raised-button
                color="primary"
                class="feedback-approve"
                (click)="saveFeedback(i)"
                [disabled]="!subtask.form.get(getFeedbackControlName(i)).value"
              >
                {{ 'PROJECT_TRACKER.SEND_FEEDBACK' | translate }}
              </button>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
